import * as React from "react";
import {connect} from "react-redux";
import {AnyAction, bindActionCreators, Dispatch} from "redux";
import {hasPlans} from "../../../mainReducerMapSelectors";
import {createInitializeUserSessionAction} from "./userSessionInitializerActions";
import {IApplicationRootState} from "../../../applicationState";
import {useEffect} from "react";

export interface IInitializeUserSessionActions {
    actions: {
        initializeUserSession: () => void;
    };
}

export interface IInitializeUserSessionProps {
    readonly hasPlans: boolean;
    // children?: React.ReactNode;
}

export interface IInitializeUserSessionOwnProps {
    children?: React.ReactNode;
}

export type IInitializeUserSessionPropsActions = IInitializeUserSessionActions & IInitializeUserSessionProps & IInitializeUserSessionOwnProps;

export const InitializeUserSessionComponent: React.FunctionComponent<IInitializeUserSessionPropsActions> = (props) => {

    useEffect(() => {
        props.actions.initializeUserSession();
    }, []);

    if (!props.hasPlans) {
        return null;
    }

    return <div data-testid="initialize-user-session">{props.children}</div>;
};

export const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): IInitializeUserSessionActions => {
    return {
        actions: bindActionCreators({
            initializeUserSession: createInitializeUserSessionAction,
        }, dispatch),
    };
};

export const mapStateToProps = (state: IApplicationRootState): IInitializeUserSessionProps => {
    return {
        hasPlans: hasPlans(state),
    };
};

const connector = connect<
    IInitializeUserSessionProps,    // StateProps
    IInitializeUserSessionActions,  // DispatchProps
    IInitializeUserSessionOwnProps, // OwnProps (none besides what mapState/mapDispatch provide)
    IApplicationRootState          // RootState
>(
    mapStateToProps,
    mapDispatchToProps,
);

export default connector(InitializeUserSessionComponent);
